import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import QnaSearchHeader from '../../components/Qna/Search/QnaSearchHeader';
import QnaSearchError from '../../components/Qna/Search/QnaSearchError';
import QnaSearchSide from '../../components/Qna/Search/QnaSearchSide';
import QnaList from '../../components/Qna/Qna/QnaList';

const QnaSearch = () => {
  const location = useLocation();
  const { searchResult } = location.state || {};
  const params = new URLSearchParams(location.search);
  const keyword = params.get('keyword');

  const [filterState, setFilterState] = useState({
    sortBy: 'Most Relevant',
    searchIn: 'All',
    onlyTutor: false,
  });
  const [appliedFilterState, setAppliedFilterState] = useState(filterState);
  const [activeCategory, setActiveCategory] = useState(null);
  const [appliedCategory, setAppliedCategory] = useState(1);
  const [searchResultState, setSearchResultState] = useState(searchResult);

  const hasResults =
    searchResultState?.content && searchResultState.content.length > 0;

  const handleUpdateSearchResult = ({ filters, category, searchResult }) => {
    if (filters) {
      setAppliedFilterState(filters);
      setFilterState(filters);
    }
    if (category !== undefined) setAppliedCategory(category);
    if (searchResult) setSearchResultState(searchResult);
  };

  return (
    <div className='bg-grayscale-gray01 min-h-screen tabletH:px-20 tabletH:pt-[120px] tabletH:pb-[200px]'>
      <QnaSearchHeader
        keyword={keyword || ''}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        filterState={filterState}
        setFilterState={setFilterState}
        appliedFilterState={appliedFilterState}
        setAppliedFilterState={setAppliedFilterState}
        onFilterApply={(result) => handleUpdateSearchResult(result)}
      />
      <div className='flex items-center justify-center'>
        <div className='grid grid-cols-1 lg:grid-cols-[minmax(273px,273px)_minmax(0,1fr)] gap-6 items-start'>
          {hasResults && (
            <div className='hidden sm:block'>
              <QnaSearchSide
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                filterState={filterState}
                setFilterState={setFilterState}
                appliedFilterState={appliedFilterState}
                onApply={handleUpdateSearchResult}
              />
            </div>
          )}

          <div className='w-full min-w-0'>
            {hasResults ? (
              <QnaList
                activeCategory={appliedCategory}
                filterState={appliedFilterState}
                useIn='QnaSearch'
                searchResult={searchResultState}
                searchKeyword={keyword || ''}
              />
            ) : (
              <QnaSearchError keyword={keyword || ''} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QnaSearch;
